import { BaseAlgorithmTuner } from './BaseTuner';
import * as DT from '../DataTypes';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class NumberTuner extends BaseAlgorithmTuner<number, DT.NumberT> {
  public constructor(planningAlgorithm: PlanningAlgorithm) {
    super(planningAlgorithm, DT.NumberT);
  }

  public getRangeName(name: string): string {
    return name + '.range';
  }

  public getValuesRange(name: string): [number, number] {
    return this._planningAlgorithm.getValueStrict(this.getRangeName(name), DT.RangeT).value;
  }
}
